import { render } from "./Kingdom.vue?vue&type=template&id=5b2bc4a0"
import script from "./Kingdom.vue?vue&type=script&lang=js"
export * from "./Kingdom.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/reports/Kingdom.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b2bc4a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b2bc4a0', __exports__)) {
    api.reload('5b2bc4a0', __exports__)
  }
  
  module.hot.accept("./Kingdom.vue?vue&type=template&id=5b2bc4a0", () => {
    api.rerender('5b2bc4a0', render)
  })

}


export default __exports__